import axios from 'axios';
import { getAccessTokenJWT } from 'utils/okta';
import okta from 'constants/okta';
import { appConfig } from 'config/appConfig';
import { getEDPCountry } from 'mapping/edpCountry';
import { getCountry } from 'utils/country';

const APIEndpoint = 'company';
const RESULTS_COUNT = 10;

let controller = new AbortController();

export const fetchCompanies = async (searchtext) => {
  controller.abort();

  if (searchtext.length < 2) return [];

  controller = new AbortController();

  return axios({
    method: 'get',
    signal: controller.signal,
    url: appConfig.API_URL + '/' + APIEndpoint,
    params: {
      searchtext: searchtext,
      country: getCountry(),
      edpCountry: getEDPCountry(),
      count: RESULTS_COUNT,
    },
    headers: {
      Authorization: okta.Bearer + getAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
    },
  })
    .then((response) => response.data)
    .catch((error) => {
      // TO-DO. Logging
      // control 401. okta redirection
      console.error(error);
      throw Error(error);
    });
};
